import { useState } from "react"
import { FaCheck, FaKey } from "react-icons/fa"
import { CreatePassword } from "./LoginService"
import { useParams, useSearchParams } from "react-router-dom"
import { AlertType, RetAPI, TypePasswordProps } from "../../Utils/Types"
import { FeedbackMessage } from "../../Components/FeedbackMessage/feedback-message"
import { IoEye, IoEyeOff } from "react-icons/io5"

export const UserCreatePassword = () => {

    const [password, setPassword] = useState('')
    const [passwordConfirm, setPasswordConfirm] = useState('')
    const [loading, setLoading] = useState<boolean>(false)
    const [visible, setVisible] = useState(false)
    const [messageType, setMessageType] = useState<AlertType>("DANGER")
    const [message, setMessage] = useState("")
    const [showPassword, setShowPassword] = useState(false)    
    const [showConfirmPassword, setConfirmShowPassword] = useState(false)    
    const [passwordInputType, setPasswordInputType] = useState<TypePasswordProps>("password")
    const [confirmPasswordInputType, setConfirmPasswordInputType] = useState<TypePasswordProps>("password")
    
    const [queryParams] = useSearchParams()
    const token = queryParams.get('token') || ''
    
    const handleChangePassword = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(e.target.value)
    }

    const handleChangePasswordConfirm = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPasswordConfirm(e.target.value)
    }

    const handleCloseMessage = () => {
        setVisible(false)
    }

    const handleCreatePassword = async () => {
        setLoading(true)
        const retorno: RetAPI = await CreatePassword(password, passwordConfirm, token)        
        if (retorno.error === false){
            setMessage("Senha gerada com sucesso, você será redirecionado")
            setMessageType("SUCCESS")
            setVisible(true)            
            setTimeout( () => {
                window.location.href = '/'
            }, 1500 )
            
        }else{
            setMessage(retorno.msg || "")
            setMessageType("DANGER")
            setVisible(true)
        }
    }

    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
        setPasswordInputType(!showPassword ? 'text' : 'password');
    }

    const toggleConfirmShowPassword = () => {
        setConfirmShowPassword(!showConfirmPassword);
        setConfirmPasswordInputType(!showConfirmPassword ? 'text' : 'password');
    }

    return <div className="flex items-center justify-center h-full w-full bg-white outline-none">
                <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage}/>
                <div className="w-full md:max-w-[500px] h-auto border border-gray-200 rounded-md shadow-md shadow-gray-300">

                    <div className="flex w-full h-20 items-center justify-around bg-indigo-900">
                        <img src="https://www.tiautomacao.com.br/imagens/logo.png" width="200" />
                        
                    </div>
                    
                    <div className="w-full h-auto flex items-center justify-center py-5">
                        <FaKey className="w-5 h-5 text-blue-500"/><span className="text-lg text-blue-500 ml-2 font-bold">Preencha os campos para criar sua senha</span>
                    </div>

                    <div className="w-full px-5 mb-5">

                        <div className={`flex justify-end items-center w-full h-auto relative`}>
                            <input type={passwordInputType} className="w-full py-5 px-2 border border-gray-300 rounded-md mt-2 outline-none" placeholder="Digite sua senha" 
                            value={password} onChange={handleChangePassword}/>

                            <button onClick={toggleShowPassword} className={`absolute mr-[20px] mt-2 h-full flex items-center text-slate-400 outline-none`}>
                                { /* }
                                <Icone icon={showPassword ? faEyeSlash : faEye} size="xl" />
                                {*/}
                                {showPassword &&
                                    <IoEye size="30px" />
                                }

                                {!showPassword &&
                                    <IoEyeOff size="30px" />
                                }

                            </button>
                        </div>

                        <div className={`flex justify-end items-center w-full h-auto relative`}>
                            <input type={confirmPasswordInputType} className="w-full py-5 px-2 border border-gray-300 rounded-md mt-2 outline-none" placeholder="Confirme sua senha" 
                            value={passwordConfirm} onChange={handleChangePasswordConfirm}/>

                            <button onClick={toggleConfirmShowPassword} className={`absolute mr-[20px] mt-2 h-full flex items-center text-slate-400 outline-none`}>
                                { /* }
                                <Icone icon={showPassword ? faEyeSlash : faEye} size="xl" />
                                {*/}
                                {showConfirmPassword &&
                                    <IoEye size="30px" />
                                }

                                {!showConfirmPassword &&
                                    <IoEyeOff size="30px" />
                                }

                            </button>
                        </div>

                        <button disabled={loading} className="flex items-center justify-center text-white w-full py-5 bg-green-500 duration-150 hover:bg-green-600 mt-4
                                            shadow-md shadow-green-700 disabled:opacity-50" onClick={handleCreatePassword}>
                            <FaCheck /> <span className="font-bold mx-1">Criar senha</span>
                        </button>
                    </div>

                    
                </div>
           </div>
}